module.exports = __webpack_public_path__ + "static/img/catapult.59419ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/catapult.png
// module id = ygmQ
// module chunks = 0